'use es6';

const isCustomObject = objectType => {
  return objectType.get('metaType') === 'PORTAL_SPECIFIC';
};
const isDefaultObject = (objectType, defaults) => {
  return objectType.get('metaType') === 'HUBSPOT' && defaults.includes(objectType.get('id'));
};

/**
 * @deprecated This function will no longer be updated or maintained. Please make use of data from the crmPropertySettingsUI framework app setting instead. https://tools.hubteam.com/lighthouse/framework-app-settings/crmPropertySettingsUI/definition
 *
 * @param {Object} data scope and objectTypeData which must be provided for proper filtering
 * @param {String[]} data.gates Gates data to check for certain permissions for objects
 * @param {String[]} data.scopes Scopes data to check for certain permissions for objects
 * @param {Map[]} data.objectTypeData Object Type Data, as immutable Map / Record data (must include metaType and id)
 */
export const getCreatableObjectTypes = ({
  gates,
  scopes,
  objectTypeData
} = {}) => {
  if (!scopes) {
    throw new Error('missing scope data');
  }
  if (!objectTypeData) {
    throw new Error('missing objectTypeData');
  }
  const canCreateProducts = scopes.includes('inbounddb-product-library-write');
  const hasMarketingEventsAccess = scopes.includes('marketing-events-read');
  const isUngatedForActivitySyncObjectAccess = gates && gates.includes('Salesforce:ActivitySyncObjects:Properties');
  const isUngatedForMeetingEventObjectAccess = gates && gates.includes('Meetings:MeetingEventCustomProperties');
  const isUngatedForLeadsProperties = gates && gates.includes('Leads:PropertySettingsAccess');
  const hasPartnerClientObjectAccess = scopes && scopes.includes('partner-client-object-access');
  const hasPartnerAccountObjectAccess = scopes && scopes.includes('partner-account-object-access') && gates && gates.includes('PartnerAccount:ObjectTypeRollout');
  const hasUserObjectAccess = scopes && scopes.includes('user-object-custom-property-write');
  const hasMarketingSMSObjectAccess = scopes && scopes.includes('sms-marketing-addon');
  const hasMarketingEmailObjectAccess = scopes && scopes.includes('email-access') && gates && gates.includes('CRM:Properties:Email');
  const defaults = [1, 2, 3, 5, 19, 53, canCreateProducts ? 7 : null, hasMarketingEventsAccess ? 54 : null, 35, 123, 142, 45, 44, isUngatedForActivitySyncObjectAccess ? 27 : null,
  // TASKS
  isUngatedForActivitySyncObjectAccess ? 49 : null,
  // EMAILS
  48,
  // CALLS
  isUngatedForMeetingEventObjectAccess ? 47 : null,
  // MEETING_EVENTS
  hasUserObjectAccess ? 115 : null,
  // USER
  hasPartnerAccountObjectAccess ? 125 : null,
  // PARTNER_ACCOUNT
  isUngatedForLeadsProperties ? 136 : null, hasPartnerClientObjectAccess ? 145 : null,
  // PARTNER_CLIENT
  162,
  //SERVICE
  hasMarketingSMSObjectAccess ? 124 : null,
  // Marketing SMS
  69,
  // SUBSCRIPTION
  421,
  // APPOINTMENT
  410,
  // COURSE
  420,
  // LISTING
  hasMarketingEmailObjectAccess ? 29 : null // Marketing Email
  ];
  return objectTypeData.filter(objectType => isCustomObject(objectType) || isDefaultObject(objectType, defaults));
};